export const CREATE_CAREER = 'CREATE_CAREER'
export const DUPLICATE_CAREER = 'DUPLICATE_CAREER'
export const UPDATE_STATUS = 'UPDATE_STATUS'
export const UPDATE_ARCHIVED = 'UPDATE_ARCHIVED'
export const UPDATE_BASIC_SETTINGS = 'UPDATE_BASIC_SETTINGS'
export const UPDATE_REDIRECT_URL = 'UPDATE_REDIRECT_URL'
